import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import { shouldMakeCustomDeclaration } from '../validator';

const RenderSelectFieldUpdateCommand = ({
  input,
  label,
  meta,
  datas,
  error,
  style,
  disabled
}) => {
  const displayError = !!(meta.submitFailed && meta.error);

  return (
    <FormControl error={displayError} style={style}>
      <InputLabel>{label}</InputLabel>
      <Select {...input} error={!!error} disabled={disabled}>
        {datas.map(data => (
          <MenuItem
            key={data.id}
            value={data.value}
            disabled={
              shouldMakeCustomDeclaration(data.value) &&
              !shouldMakeCustomDeclaration(input.value)
            }
          >
            {data.name}
          </MenuItem>
        ))}
      </Select>
      {!shouldMakeCustomDeclaration(input.value) ? (
        <FormHelperText>
          Vous pouvez uniquement sélectionner un pays dans l&lsquo;union
          européenne
        </FormHelperText>
      ) : (
        ''
      )}
    </FormControl>
  );
};

RenderSelectFieldUpdateCommand.propTypes = {
  label: PropTypes.string,
  dataCy: PropTypes.string,
  style: PropTypes.object,
  error: PropTypes.string,
  datas: PropTypes.array.isRequired,
  meta: PropTypes.object.isRequired,
  input: PropTypes.object.isRequired,
  disabled: PropTypes.bool
};

export default RenderSelectFieldUpdateCommand;
